import React, { useEffect, useRef, useState } from 'react';

import useDeviceType, { MOBILE_SCREEN } from '@travel/traveler-core/hooks/useDeviceType';
import { Sticky } from '@travel/ui';

type Props = {
  /** Children to be floating or static  */
  children: React.ReactNode;
  /** Children height form useDivElementHeight */
  childHeight?: number;
  /** Custom style for wrapper when it is on floating state */
  floatingStateClassName?: string;
  /** Callback to be called when floating state changed */
  onChange?: (isFloating: boolean) => void;
};

function SubHeader(props: Props) {
  const { childHeight } = props;
  const isMobile = useDeviceType() === MOBILE_SCREEN;

  const [childrenHeight, setChildrenHeight] = useState<number | null>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!childHeight) {
      const height = wrapperRef.current?.offsetHeight;
      if (height) {
        setChildrenHeight(height);
      }
    } else {
      setChildrenHeight(childHeight);
    }
  }, [childHeight]);

  return (
    <div
      data-testid="subHeader-wrapper"
      ref={wrapperRef}
      style={childrenHeight ? { height: childrenHeight } : undefined}
    >
      {isMobile ? (
        <Sticky
          threshold={0.75}
          rootMargin="-24px 0px 0px 0px"
          isFloatingByDefault={false}
          position="top"
          floatingStateClassName={props.floatingStateClassName}
          onChange={props.onChange}
        >
          {props.children}
        </Sticky>
      ) : (
        props.children
      )}
    </div>
  );
}

export default SubHeader;
